<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallAction from '../CallAction.vue';

  import TransferIcon from './TransferIcon.vue';
</script>

<template>
  <call-action :title="trans('voip.calls.call_action.transfer_trans')">
    <transfer-icon />
  </call-action>
</template>
